import { useMatches } from '@remix-run/react';

const useIsLoggedIn = () => {
  const root = useMatches()[0];

  if (!root) {
    throw new Error('This hook should only be called in child routes to root');
  }

  return root.data.isLoggedIn;
};

export default useIsLoggedIn;
